import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PaymentRedirect.module.css';

const PaymentRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Payment redirect page loaded - redirecting to profile');
    
    // Add payment_completed parameter to URL and redirect to main page
    // This will trigger the redirect logic in App.jsx
    window.location.href = '/?payment_completed=true';
  }, [navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.loadingCard}>
        <div className={styles.spinner}></div>
        <h2 className={styles.title}>Payment Successful!</h2>
        <p className={styles.message}>Redirecting to your profile...</p>
      </div>
    </div>
  );
};

export default PaymentRedirect; 